export const LOADING_GENERAL_INFO = "LOADING_GENERAL_INFO";
export const SAVE_LOADING_GENERAL_INFO = "SAVE_LOADING_GENERAL_INFO";
export const GET_GENERAL_INFO = "GET_GENERAL_INFO";
export const FORM_FAIL_GENERAL_INFO = "FORM_FAIL_GENERAL_INFO";
export const GENERAL_INFO_FAIL = "GENERAL_INFO_FAIL";
export const LOADING_GENERAL_INFO_BY_ID = "LOADING_GENERAL_INFO_BY_ID";
export const GET_GENERAL_INFO_BY_ID = "GET_GENERAL_INFO_BY_ID";
export const SAVE_LOADING_GENERAL_INFO_BY_ID =
  "SAVE_LOADING_GENERAL_INFO_BY_ID";
export const LOADING_DESCRIPTOR_MANUAL = "LOADING_DESCRIPTOR_MANUAL";
export const GET_DESCRIPTOR = "GET_DESCRIPTOR";
export const LOADING_DESCRIPTOR = "LOADING_DESCRIPTOR";
export const FAIL_DESCRIPTOR = "FAIL_DESCRIPTOR";
export const FORM_FAIL_DESCRIPTOR = "FORM_FAIL_DESCRIPTOR";
export const DOC_DESCRIPTOR = "DOC_DESCRIPTOR";
export const LOADING_PDF_DESCRIPTOR = "LOADING_PDF_DESCRIPTOR";
export const PDF_DESCRIPTOR = "PDF_DESCRIPTOR";
